import { render, staticRenderFns } from "./upload-files.vue?vue&type=template&id=6f8eac92&scoped=true&"
import script from "./upload-files.vue?vue&type=script&lang=js&"
export * from "./upload-files.vue?vue&type=script&lang=js&"
import style0 from "./upload-files.vue?vue&type=style&index=0&id=6f8eac92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8eac92",
  null
  
)

export default component.exports